module.exports = __webpack_public_path__ + "media/images/user-manage-d28b543cc8a2b7b81076e9e487017d4d.svg";